// extracted by mini-css-extract-plugin
export default {"submitWrapper":"UpdatePasswordForm-module__submitWrapper___OdEHX AccountPage-module__submitWrapper___kQgng"};